module.exports = [{
      plugin: require('../node_modules/@wkocjan/gatsby-theme-intro/node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-ackee-tracker/gatsby-browser.js'),
      options: {"plugins":[],"domainId":"487c7246-82c8-443a-a049-22aa49e99ae7","server":"https://traffic.autonomaker.com","ignoreLocalhost":true,"detailed":true,"ignoreOwnVisits":false},
    }]
